import React, { useEffect, useState } from 'react';
import moment from 'moment';

// Components
import MainCard from '../../../components/MainCard/MainCard';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import Loading from '../../../components/Loading/Loading';
import FichaEnviarResiduos from './FichaEnviarResiduos';
import NovoEnviarResiduo from './NovoEnviarResiduo';

//API
import redestinacao_api from '../../../api/redestinacao_api';

//Helpers
import { showMessage } from '../../../helpers/message';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';


function EnviarResiduos() {
    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    const [listRedestinacoes, setListRedestinacoes] = useState([]);

    //Estado de controle para exibição da tela de ficha do gerador
    const [ficha, setFicha] = useState(null);

    //Estado de controle para exibição da tela de novo gerador
    const [novo, setNovo] = useState(false);

    //Cabeçalhos  da tabela de entrada de residuos
    const headersTabela = [
        { value: "Data Registro", objectValue: "dataRegistro" },
        { value: "Status", objectValue: "status" },
        { value: "Transportador", objectValue: "transportadorFantasia" },
        { value: "Destino", objectValue: "destinoAlvo" },
        { value: "Veiculo", objectValue: "placaVeiculo" },
        { value: "Data Coleta", objectValue: "dataColeta" },
    ];

    const loadRedestinacoes = () => {
        setLoading(true);
        redestinacao_api.GetList().then(response => {
            response.data = response.data.map(value => {
                value.dataRegistro = moment(value.dataRegistro).format("DD/MM/YYYY");
                value.dataColeta = value.dataColeta ? moment(value.dataColeta).format("DD/MM/YYYY") : ""
                return value;
            })
            setListRedestinacoes(response.data)
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    const remover = (item) => {
        setLoading(true);
        redestinacao_api.DeletaRedestinacao(item.id)
        .then(response => {
            showMessage("Sucesso", "Operação executada com sucesso.", "success", () => loadRedestinacoes());
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    //Função do botão visualizar da lista
    const visualizar = (item) => { setFicha(item.id) };

    const removeItem = (row) => {
        if (row.status == "Pendente" || row.status == "Coletado")
           return actionsTable.remover(remover)
        else 
            return null;
    }

    //Variavel que guarda as ações da tabela
    const actions = [removeItem, actionsTable.visualizar(visualizar)];

    useEffect(() => {
        loadRedestinacoes()
    }, []);


     //Controle da exibição da tela de ficha
     if (ficha) {
        return <FichaEnviarResiduos
            btnVoltar={() => {
                setFicha(null);
                loadRedestinacoes();
            }}
            id={ficha}
        />
    }

    if (novo) {
        return <NovoEnviarResiduo
            btnVoltar={() => {
                setNovo(null)
                loadRedestinacoes();
            }}
        />
    }

    return <MainCard
        noCard
        btnCadastro={"Adicionar"}
        onClickBtnCadastro={() => setNovo(true)}
    >
        {loading && <Loading />}
        <TabelaListagem
            actions={actions}
            title={"Lista de envio resíduo"}
            options={{ print: false, search: true, pagination: true }}
            headers={headersTabela}
            items={listRedestinacoes}
        />
    </MainCard>;
}

export default EnviarResiduos;